import { Injectable } from '@angular/core';
import { CartModification } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter, ConverterService } from '../../../../core/util';
import { ORDER_ENTRY_NORMALIZER } from './converters';

@Injectable({ providedIn: 'root' })
export class CartModificationNormalizer implements Converter<Occ.CartModification, CartModification> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.CartModification, target?: CartModification): CartModification {
    if (source) {
      target = this.convertCartModification(source);
    }

    return target;
  }

  convertCartModification(source: Occ.CartModification): CartModification {
    if (source) {
      const { entry, ...target } = source;
      return {
        ...target,
        entry: this.converter.convert(entry, ORDER_ENTRY_NORMALIZER),
      };
    } else {
      return undefined;
    }
  }
}
